import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelASubCardHeaderText({text}) {
    // Used through LevelAScreen to display card header text

    // BUILD
    if (isNullOrUndefined(text))
        return null
    return (
        <div className={"w-full flex justify-center items-center"}>
            <span className={"text-[14px] font-medium text-greyLight7"}>
                {text}
            </span>
        </div>
    );
}